import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Summary from './Summary';
import Samples from './Samples';
import Map from './Map';

export default class SinglePage extends Component {
  static propTypes = {
    focusData: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      fdata: this.props.focusData.filter(
        fdata => String(fdata.focusID) === String(this.props.match.params.id)
      )
    };
  }

  render() {
    const fdata = this.state.fdata[0];

    return (
      <div className='ui container'>
        <Link to='/' className='ui left labeled icon brown button'>
          <i className='left arrow icon'></i>
          Back
        </Link>
        {this.state.fdata.length === 1 ? (
          <div>
            <div className='ui raised segment'>
              <div className='ui grid stackable'>
                <div className='eight wide column'>
                  <div className='ui large vertical list'>
                    <div className='item'>
                      <div className='ui large green massive label'>
                        Culture Name
                        <div className='detail'>{fdata.culture_name}</div>
                      </div>
                    </div>

                    <div className='item'>
                      <div className='ui large green massive label'>
                        Time
                        <div className='detail'>
                          {fdata.start_date === '9999'
                            ? 'Unknown'
                            : fdata.start_date === fdata.end_date
                            ? fdata.start_date
                            : `${fdata.start_date}-${fdata.end_date}`}
                        </div>
                      </div>
                    </div>

                    <div className='item'>
                      <div className='ui large green massive label'>
                        Specific Sub-Cultural Focus
                        <div className='detail'>
                          {fdata.community_name === 'None'
                            ? fdata.district_name === 'None'
                              ? fdata.focus_note === 'None'
                                ? 'Unknown'
                                : fdata.focus_note
                              : fdata.district_name
                            : fdata.community_name}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='eight wide column'>
                  {(fdata.avg_loc.avg_spec_lat ||
                    fdata.avg_loc.avg_soc_lat) && (
                    <div className='ui segment raised right aligned'>
                      <Map
                        latitude={
                          fdata.avg_loc.avg_spec_lat
                            ? parseFloat(fdata.avg_loc.avg_spec_lat)
                            : parseFloat(fdata.avg_loc.avg_soc_lat)
                        }
                        longitude={
                          fdata.avg_loc.avg_spec_long
                            ? parseFloat(fdata.avg_loc.avg_spec_long)
                            : parseFloat(fdata.avg_loc.avg_soc_long)
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <Summary fdata={fdata} />
            <Samples fdata={fdata} />
          </div>
        ) : (
          <div className='ui segment center aligned'>
            <h1>No profile found. Please return to homepage!</h1>
          </div>
        )}
      </div>
    );
  }
}
